import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "mobileServicesList", "toggleButton", "mobileServicesToggle"];
  static classes = ["default", "active"];

  connect() {
    // Set initial state
    this.menuTarget.classList.remove("hidden");
    this.menuTarget.classList.add("flex", ...this.defaultClasses);
    this.menuTarget.inert = true;
    this.menuTarget.setAttribute("aria-hidden", "true");
    this._handleKeydown = this._handleKeydown.bind(this);
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleKeydown);
  }

  toggle() {
    if (this.menuTarget.classList.contains(...this.activeClasses)) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.menuTarget.inert = false;
    this.menuTarget.setAttribute("aria-hidden", "false");
    this.menuTarget.classList.remove(...this.defaultClasses);
    this.menuTarget.classList.add(...this.activeClasses);
    this.toggleButtonTarget.setAttribute("aria-expanded", "true");
    this.toggleButtonTarget.setAttribute("aria-label", this.toggleButtonTarget.getAttribute("aria-label").replace(this._openLabel, this._closeLabel));
    document.addEventListener("keydown", this._handleKeydown);
    this.menuTarget.querySelector("button, a")?.focus();
  }

  close() {
    this.menuTarget.classList.remove(...this.activeClasses);
    this.menuTarget.classList.add(...this.defaultClasses);
    this.toggleButtonTarget.setAttribute("aria-expanded", "false");
    this.toggleButtonTarget.setAttribute("aria-label", this.toggleButtonTarget.getAttribute("aria-label").replace(this._closeLabel, this._openLabel));
    document.removeEventListener("keydown", this._handleKeydown);
    this.toggleButtonTarget.focus();
    this.menuTarget.inert = true;
    this.menuTarget.setAttribute("aria-hidden", "true");
  }

  toggleMobileServicesList(e) {
    e.preventDefault();
    const collapsed = this.mobileServicesListTarget.classList.toggle("hidden");
    this.mobileServicesToggleTarget.setAttribute("aria-expanded", String(!collapsed));
  }

  _handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  get _openLabel() {
    return document.documentElement.lang === "fr" ? "Ouvrir le menu" : "Open menu";
  }

  get _closeLabel() {
    return document.documentElement.lang === "fr" ? "Fermer le menu" : "Close menu";
  }
}
